import ButtonType04 from './ButtonType04';
import Popup from './Popup';
import './simplePopup.scss';

interface ISimplePopup {
  open: boolean;
  title: React.ReactNode;

  children?: React.ReactNode;

  isSingleButton?: boolean;

  isOrangeButton?: boolean;

  confirmButtonTxt?: string;

  onCancelButtonClick?(): void;
  onConfirmButtonClick?(): void;
}

const SimplePopup = ({
  open,
  title,
  children,
  isSingleButton = false,
  isOrangeButton = false,
  confirmButtonTxt,
  onCancelButtonClick,
  onConfirmButtonClick
}: ISimplePopup) => {
  const renderButtonList = () => {
    if (isSingleButton) {
      if (isOrangeButton) {
        return <ButtonType04 btnName="btn-full01" txt="확인" fn={() => onCancelButtonClick?.()} />;
      } else {
        return <ButtonType04 btnName="btn-full03" txt="확인" fn={() => onCancelButtonClick?.()} />;
      }
    } else {
      return (
        <>
          <ButtonType04 btnName="btn-full03" txt="취소" fn={() => onCancelButtonClick?.()} />
          {confirmButtonTxt && (
            <ButtonType04 btnName="btn-full01" txt={confirmButtonTxt} fn={() => onConfirmButtonClick?.()} />
          )}
          {!confirmButtonTxt && (
            <ButtonType04 btnName="btn-full01" txt="확인" fn={() => onConfirmButtonClick?.()} />
          )}
        </>
      );
    }
  };

  return (
    <Popup open={open} pos="middle">
      <div className="simple-popup-mobile">
        <div className="popup-container">
          <div className="popup-header">
            <h1 className="tit01">{title}</h1>
          </div>

          {children && (
            <div className="popup-content">
              <div className="txt-area01">{children}</div>
            </div>
          )}

          <div className={`popup-footer ${isSingleButton && 'single'}`}>{renderButtonList()}</div>

          <button className="btn-close" onClick={() => onCancelButtonClick?.()}>
            <i className="icon-close"></i>
          </button>
        </div>
      </div>
    </Popup>
  );
};

export default SimplePopup;
